export enum UserRole {
  admin = 'Administrator',
  coach = 'Coach',
  contentSearch = 'ContentSearch',
  contentViewer = 'Content Viewer',
  csAdministrator = 'CS Administrator',
  curriculumReviewer = 'CurriculumReviewer',
  editor = 'Editor',
  editorLite = 'Editor Lite',
  firewallAdministrator = 'FirewallAdministrator',
  licenseManager = 'License Manager',
  mathConsultant = 'Math Consultant',
  mathLead = 'Math Lead',
  mcChiefSuperintendent = 'MC Chief Superintendent',
  mcDirector = 'MC Director',
  mcMathCoach = 'MC Math Coach',
  mcMathConsultant = 'MC Math Consultant',
  mcMathLead = 'MC Math Lead',
  mcOther = 'MC Other',
  mcPrincipal = 'MC Principal',
  mcSuperIntendent = 'MC Superintendent',
  mediaAdmin = 'Media Administrator',
  mediaRepresentative = 'Media Representative',
  parent = 'Parent',
  premiumSchoolAdministrator = 'PremiumSchoolAdministrator',
  principal = 'Principal',
  principalAdministrator = 'Principal Administrator',
  purchaser = 'Purchaser',
  questionCloner = 'QuestionCloner',
  reviewer = 'Reviewer',
  salesRepresentative = 'Sales Representative',
  schoolAdminApprover = 'SchoolAdminApprover',
  slsChiefSuperIntendent = 'SLS Chief Superintendent',
  slsDirector = 'SLS Director',
  slsLead = 'SLS Lead',
  slsMathCoach = 'SLS Math Coach',
  slsMathConsultant = 'SLS Math Consultant',
  slsMathLead = 'SLS Math Lead',
  slsOther = 'SLS Other',
  slsPrincipal = 'SLS Principal',
  slsSuperintendent = 'SLS Superintendent',
  student = 'Student',
  superintendent = 'Superintendent',
  teacher = 'Teacher',
  translator = 'Translator',
  vicePrincipal = 'Vice-Principal',
  viewOnlyParent = 'ViewOnlyParent',
  teacherReports = 'Teacher Reports',
  studentReports = 'Student Reports',
  parentReports = 'Parent Reports',
  homeAdministrator = 'Home Administrator',
  regionalLeader = 'Regional Leader',
  demoSiteAdmin = 'Demo Site Admin'
}
